// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_edf5249f","content":"rdg_a83ac707","footer":"rdg_a2032064","header":"rdg_11719e50","breadcrumbLink":"rdg_13e496c7","checkoutLogo":"rdg_37a56d81"};